<div class="table-filters">
  <div class="filter-button" (click)="openFilterMenu()">
    <app-custom-icon
      [iconPath]="'assets/icons/general-icons.svg'"
      [imageName]="'filter'"
      [imageSize]="'18'">
    </app-custom-icon>
    <span>Filter</span>
  </div>
  @for (filter of currentFilters | keyvalue; track filter) {
    @if (isDisplayable(filter)) {
      @switch (filter.key) {
        @case ('status') {
          <app-topbar-filter-button
            [filter]="filter"
            [dataToDisplay]="getStatuses(filter.value)"
          (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
        }
        @case ('responsiblePilot') {
          <app-topbar-filter-button
            [filter]="filter"
            [dataToDisplay]="'Individual: ' + (filter.value | findInList:userList)?.label"
          (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
        }
        @case ('groups') {
          <app-topbar-filter-button
            [filter]="filter"
            [dataToDisplay]="filter.value | filterChipLabel:groupFilterOptions?.all:'Group'"
          (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
        }
        @case ('flightDate') {
          <app-topbar-filter-button
            [filter]="filter"
            [closeActive]="false"
            [dataToDisplay]="filter.value | dateIntervalToString"
          (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
        }
        @case ('aircraft') {
          <app-topbar-filter-button
            [filter]="filter"
            [dataToDisplay]="('asset.singular' | term) + ': ' + (filter.value | findInList:aircraftList)?.label"
          (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
        }
        @case ('airport') {
          <app-topbar-filter-button
            [filter]="filter"
            [dataToDisplay]="'Airport: ' + filter.value.icao_code + ' ' + filter.value.name"
          (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
        }
        @case ('formType') {
          <app-topbar-filter-button
            [filter]="filter"
            [dataToDisplay]="'Form: ' + (filter.value | assessmentTitle | async)"
          (resetClicked)="resetFilter(filter.key)"></app-topbar-filter-button>
        }
        @default {
        }
      }
    }
  }
</div>
